import "./App.scss";

import {useSignerData} from "../../hook/useSignerData";
import Header from "./header/Header";
import SwapFlow from "../../swap/flow/SwapFlow";
import SwapFormContainer from "../../swap/form/container/SwapFormContainer";
import {initThemeVariables} from "../util/theme/themeUtils";

function App() {
  initThemeVariables();

  useSignerData();

  return (
    <div className={"is-flex-column has-space-between widget"}>
      <SwapFlow>
        <Header />

        <SwapFormContainer />
      </SwapFlow>
    </div>
  );
}

export default App;
